import { Alert, Box, Grid, IconButton, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { Dispatch, SetStateAction, useContext } from "react";

import { Template } from "features/Influencer/ContactList/schema";

import styles from "./styles";

interface Props {
  setOpenEditFallbackDrawer: Dispatch<SetStateAction<boolean>>;
  fallbackTemplates: Template[];
}

const DefaultTemplate = ({
  setOpenEditFallbackDrawer,
  fallbackTemplates,
}: Props) => {
  const { setEditTemplateDialogId } = useContext(OutreachTemplatesContext);

  return (
    <Box sx={styles.defaultTemplateBox}>
      <Grid
        container
        onClick={() => setOpenEditFallbackDrawer(true)}
        gap={2}
        alignItems={"center"}
        sx={{ position: "relative" }}
      >
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setOpenEditFallbackDrawer(true);
          }}
          sx={{
            color: grey[600],
            flexShrink: 0,
            position: "absolute",
            top: 0,
            right: 10,
            fontSize: 12,
          }}
        >
          <Box component="span" className="fa-regular fa-pen" />
        </IconButton>
        <Grid item xs={12} lg="auto">
          <Typography variant="h6" sx={{ mb: 1 }}>
            Current fallback templates{" "}
          </Typography>
          {fallbackTemplates.length > 0 ? (
            <Box gap={1}>
              {fallbackTemplates.map((t, index) => (
                <Box
                  key={t.id}
                  sx={{
                    backgroundColor: "white",
                    p: 2,
                    borderRadius: 3,
                    mb: 2,
                    border: "1px solid",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (t.id) setEditTemplateDialogId(t.id.toString());
                  }}
                >
                  <Typography
                    noWrap
                    sx={{
                      maxWidth: 350,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: 12,
                    }}
                  >
                    {t.name}
                  </Typography>
                </Box>
              ))}
            </Box>
          ) : (
            <Alert severity="warning">
              No default template is set. Please set one to ensure emails can be
              sent.
            </Alert>
          )}
        </Grid>
        <Grid item xs={12} lg gap={1}>
          <Typography
            sx={{ fontSize: { xs: 12, lg: 14 }, p: { xs: 0, lg: 3 } }}
          >
            <Box
              component="i"
              className="fa-solid fa-circle-info"
              sx={{ mr: 0.5, color: "green.main" }}
            />
            These templates are used when AI can't confidently identify a
            brand's category. Keep it broad enough to work as a pitch for any
            brand.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DefaultTemplate;
